module.exports = __webpack_public_path__ + "static/assets/8285380261b5fe5a2049fa012f886625.gif";